import {styled} from 'stitches.config'

export const HeroTitle = styled('h1', {
    color: '$accent-black',
    fontSize: '$h2',
    fontWeight: '$medium',
    textAlign: 'center',
    lineHeight: '$h1',
    width: '100%',
    maxWidth: '387px',
    margin: 'auto',
    '@bp3': {
      maxWidth: 'none',
      fontSize: '$h1',
    },
  })
  
  export const HeroSubtitle = styled('h2', {
    color: '$accent-black',
    fontWeight: '$regular',
    textAlign: 'center',
    width: '100%',
    maxWidth: '440px',
    padding: '0 10px',
    margin: 'auto',
    marginTop: '$2',
    fontSize: '$body',
    '@bp3': {
      marginTop: '$2',
      maxWidth: 'none',
      width: '600px',
      padding: 0,
      fontSize: '$bodyLarge'
    },
  })